export const ADDRESSBOOK_COLUMN_HEADERS = {
  key: 'Key',
  name: 'Name',
  accountName: 'DD Account Name',
  accountId: 'DD Account ID',
  id: 'DD Addressbook ID',
  country: 'Country',
  contacts_count: 'Contacts Count',
  isDeletedFromDD: 'Deleted from DD',
  party_id: 'Party Service ID',
  party_name: 'Party Service Name',
  category: 'Optin Category',
  tag: 'Optin Tag',
  processed: 'Processed',
  dataCapture: 'Data Capture Enabled',
  excludeFromReporting: 'Exclude from Reporting',
  nonConsented: 'Non Consented',
  communityLeaderId: 'Community Leader ID',
  communityLeaderName: 'Community Leader Name',
  communityLeaderMappingValid: 'Community Leader Mapping Valid',
  created: 'Created',
  modified: 'Modified',
  doNotShare: 'Do Not Share',
} as const;

export type AddressbookDataColumnId = keyof typeof ADDRESSBOOK_COLUMN_HEADERS;
export type AddressbookColumnId = 'selection' | AddressbookDataColumnId;

export interface AddressbookColumnOptions {
  canBulkUpdate: boolean;
  communityMappingEnabled: boolean;
  addressbooksNewFlagsEnabled: boolean;
}

const CORE_COLUMN_IDS: readonly AddressbookDataColumnId[] = [
  'key',
  'name',
  'accountName',
  'accountId',
  'id',
  'country',
  'contacts_count',
  'isDeletedFromDD',
  'party_id',
  'party_name',
  'category',
  'tag',
  'processed',
  'dataCapture',
  'excludeFromReporting',
  'nonConsented',
];

const COMMUNITY_COLUMN_IDS: readonly AddressbookDataColumnId[] = [
  'communityLeaderId',
  'communityLeaderName',
  'communityLeaderMappingValid',
];

const TIMESTAMP_COLUMN_IDS: readonly AddressbookDataColumnId[] = [
  'created',
  'modified',
];

export const getAddressbookColumnIds = ({
  canBulkUpdate,
  communityMappingEnabled,
  addressbooksNewFlagsEnabled,
}: AddressbookColumnOptions): AddressbookColumnId[] => [
  ...(canBulkUpdate ? (['selection'] as const) : []),
  ...CORE_COLUMN_IDS,
  ...(communityMappingEnabled ? COMMUNITY_COLUMN_IDS : []),
  ...TIMESTAMP_COLUMN_IDS,
  ...(addressbooksNewFlagsEnabled ? (['doNotShare'] as const) : []),
];
